import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationBlockedVisitors } from "./shared/data.service";
import { DialogService } from "primeng/dynamicdialog";
import { MsVisitorAddComponent } from "../shared/ms-visitor-add/ms-visitor-add.component";
import { MsVisitorEditComponent } from "../shared/ms-visitor-edit/ms-visitor-edit.component";
import { MsBlockedVisitorImportComponent } from "./ms-blocked-visitor-import/ms-blocked-visitor-import.component";
import { MsBlockedVisitorExportComponent } from "./ms-blocked-visitor-export/ms-blocked-visitor-export.component";
import { MsVisitorBlockedExceptionsComponent } from "./ms-visitor-blocked-exceptions/ms-visitor-blocked-exceptions.component";
import { ReportService } from "../../Report/report.service";
import { MsBlockedPrintConfirmComponent } from "./ms-blocked-print-confirm/ms-blocked-print-confirm.component";

@Component({
	selector: "app-multi-station-blocked-visitors",
	templateUrl: "./multi-station-blocked-visitors.component.html",
	styleUrls: ["./multi-station-blocked-visitors.component.css"],
})
export class MultiStationBlockedVisitorsComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationBlockedVisitors, private dialogService: DialogService, private reportService: ReportService) {}

	ngOnInit(): void {
		this.loadPerson();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	LoadingTable: boolean = false;
	lstPerson: any;
	SelectedPerson: any;

	pagerows: any = 10;
	pagefirst: any = 0;

	lstStatusDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "IDIssuer", header: "State" },
		{ field: "LicenseNbr", header: "License Number" },
		{ field: "Notes", header: "Notes" },
		// { field: 'StatusDesc', header: 'Status' },
		// { field: 'ExceptionCount', header: 'Exceptions (By Facility)'}
	];

	ImageDict: Map<number, string> = new Map(); //Dictionary that matches Visitor Pass IDs to base64 of image
	lstImageCalls: any = [];

	Processing: boolean = false;
	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadPerson() {
		this.LoadingTable = true;

		//Reload Images
		this.ImageDict = new Map();
		this.lstImageCalls = [];

		var result = this.visitorService.BlockedVisitorSelectList();
		result.subscribe(
			(response) => {
				this.lstPerson = response;

				//Load Data Filter Lists
				this.lstStatusDesc = Array.from(new Set(this.lstPerson.map((item: any) => item.StatusDesc))).sort();

				this.LoadingTable = false;
			},
			(error) => {
				this.LoadingTable = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadPerson();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(MsVisitorAddComponent, {
			header: "Add Blocked Visitor",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				IsBlocked: true,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a Visitor to Edit";
			return;
		}

		var ref = this.dialogService.open(MsVisitorEditComponent, {
			header: "Edit Visitor",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				IsBlocked: true,
				PersonID: this.SelectedPerson.PersonID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onImport() {
		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(MsBlockedVisitorImportComponent, {
			header: "Import Blocked Visitors",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onExport() {
		var ref = this.dialogService.open(MsBlockedVisitorExportComponent, {
			header: "Export Blocked Visitors",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onBlockExceptions() {
		this.errorMessage = "";

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a Visitor to Add Blocked Exceptions";
			return;
		}

		if (this.SelectedPerson.IsOffender == true) {
			this.errorMessage = "Visitor is not blocked at any facility";
			return;
		}

		var ref = this.dialogService.open(MsVisitorBlockedExceptionsComponent, {
			header: "Add Block Exceptions",
			width: "800px",
			data: {
				//INSERT Custom Data here
				PersonID: this.SelectedPerson.PersonID,
				FirstName: this.SelectedPerson.FirstName,
				LastName: this.SelectedPerson.LastName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPerson();
			}
		});
	}

	onPrint() {
		var ref = this.dialogService.open(MsBlockedPrintConfirmComponent, {
			header: "Report Options",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response.Success == true) {
				this.onFinishPrint(response.OutputTypeID, response.SelectOptionID);
			}
		});
	}

	onFinishPrint(OutputTypeID, SelectOptionID) {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam(SelectOptionID);
		this.Processing = true;

		var reportID = 448;

		var result = this.reportService.Print(reportID, strParam, 0, OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.Processing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.Processing = false;
			}
		);
	}

	GetStrParam(SelectOptionID): string {
		var strParam: string = "";

		var visitorTypeID = 0;

		//Parameter 1: IncludeAllowedOffender
		strParam += (SelectOptionID == 0 ? 0 : 1) + "|IncludeAllowedOffender";

		//Parameter 2: AllowedOffenderOnly
		strParam += "," + (SelectOptionID == 2 ? 1 : 0) + "|AllowedOffenderOnly";

		//Parameter 3: VisitorTypeID
		strParam += "," + visitorTypeID + "|VisitorTypeID";

		//Parameter 4: SortBy
		strParam += "," + "Name" + "|SortBy";

		//Parameter 5: SortDirection
		strParam += "," + "Ascending" + "|SortDirection";

		//Parameter 6: ImageLogo
		strParam += "," + "" + "|Imagelogo";

		return strParam;
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(val) {
		this.SelectedPerson = val;

		this.onEdit();
	}
	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingTable == true || this.Processing == true;
	}

	GetPhotoData(PersonID) {
		if (this.ImageDict.has(PersonID)) {
			return this.ImageDict.get(PersonID);
		} else {
			var found = false;

			for (var z = 0; z < this.lstImageCalls.length; z++) {
				var next = this.lstImageCalls[z];

				if (next == PersonID) {
					found = true;
					break;
				}
			}

			if (found) {
				return "assets\\images\\loading.gif";
				//return this.ImageDict.get(-1); //Already made the webservice call
			} else {
				//Make the webservice call 1 time
				this.lstImageCalls = [...this.lstImageCalls, PersonID]; //Add to list of calls made

				var result = this.visitorService.GetPhotoByPerson(PersonID);
				result.subscribe(
					(response: any) => {
						this.ImageDict.set(PersonID, response.VisitorPhoto);

						return response.VisitorPhoto;
					},
					(error) => {
						return this.ImageDict.get(-1); //Missing Photo
					}
				);
			}
		}
	}

	/////////////////////////////////////////////////////////////////////////
}
